module.exports = __webpack_public_path__ + "img/vampire_small.89d0281c.png";